// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".past-reservation-warning[data-v-91626356]{font-weight:bold;text-align:center;font-size:11px}[data-v-91626356] .btn{min-width:2.7rem !important}[data-v-91626356] .btn:focus{box-shadow:none !important}", ""]);
// Exports
module.exports = exports;
